import fetch from "../../utils/fetch";
// 获取未处理文件列表
export function getBaseFileInfo(data) {
  return fetch({
    url: "/base_file/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 上传文件
export function uploadFiles(data) {
  return fetch({
    url: "api/categories/upload_file_by_user",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}
// 删除文件
export function deleteFile(id) {
  return fetch({
    url: "/base_file/" + id + "/",
    method: "delete",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
